export default __webpack_public_path__ + "static/bg-blood--mobile-2b8d457729600f5156a5f4c716b6be5e.jpg";